import { graphql } from 'gatsby';
import ComponentApi from 'src/components/ComponentApi';
import CodeView from 'src/components/CodeView';
import basicOverlay from 'src/examples/Overlay/default';
import triggerOverlay from 'src/examples/Overlay/trigger';
import shortTooltip from 'src/examples/Overlay/tooltip';
import shortTooltipWhite from 'src/examples/Overlay/tooltipWhite';
import longTooltip from 'src/examples/Overlay/tooltipLong';
import basicDelay from 'src/examples/Overlay/basicDelay';
import delayWithHoverOverlay from 'src/examples/Overlay/delayWithHoverOverlay';
import * as React from 'react';
export default {
  graphql,
  ComponentApi,
  CodeView,
  basicOverlay,
  triggerOverlay,
  shortTooltip,
  shortTooltipWhite,
  longTooltip,
  basicDelay,
  delayWithHoverOverlay,
  React
};